// extracted by mini-css-extract-plugin
export default {"wrapper":"KSyeC__wrapper","label":"a43Mk__label","inputWrapper":"dHCUK__inputWrapper","input":"wUqbU__input"};